/* eslint-disable react-hooks/exhaustive-deps */
import {
  USER_GENDER,
  FORMAT_DD_MM_YYYY,
  ID_TYPE,
  EditableHsStatus,
  ETHNIC_GROUP,
} from '../../constants';
import { DetailWrapped, WrapperButtonUpload } from './styled';
import {
  AddImageOutlineIcon,
  CheckboxActive,
  CheckboxDefault,
} from '@/assets/svg';
import PhoneInput from '@/components/PhoneInput';
import { doctorStatus } from '@/enum/RequestEnum';
import { renderUnitNumber } from '@/helpers';
import { UploadSingle } from '@/module/common/component';
import ControlDatepicker from '@/module/common/component/ControlDatepicker';
import FiltedBodyCell from '@/module/common/component/FiltedBodyCell';
import InlineTable from '@/module/common/component/InlineTable';
import SignedUploadSingle from '@/module/common/component/UploadSingle/SignedUploadSingle';
import DividerHeader from '@/module/common/componentUI/DividerHeader';
import TableCellFilted from '@/module/common/componentUI/TableCellFilted';
import { NATIONALITY, renderCorporateColumn } from '@/module/patient/constants';
import {
  Typography,
  Grid,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  FormHelperText,
  TableHead,
  TableRow,
  TableCell,
  IconButton,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Delete } from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import { LocalizationProvider } from '@material-ui/pickers';
import MomentUtils from '@material-ui/pickers/adapter/moment';
import { isEmpty, get, cloneDeep, set, capitalize } from 'lodash';
import moment from 'moment';
import React, { useState } from 'react';

const UNIT_NUMBER_VALID_REGEX = /^[0-9]{1,2}-[0-9]{1,4}$/;

const CustomTextField = withStyles({
  root: {
    '& .MuiInputBase-adornedStart': {
      '& .MuiTypography-root': {
        fontSize: 16,
        color: '#333333',
      },
      '& .MuiInputAdornment-positionStart': {
        marginRight: 0,
      },
      '& input': {
        marginLeft: 0,
      },
    },
  },
})(TextField);

// Define columnCorporatePlans
const columnCorporatePlans = renderCorporateColumn();

const PersonalInformation = ({
  personalInfo,
  setPersonalInfo,
  errors,
  lstIdentityUrl,
  isChildren,
  unitNumber,
  setUnitNumber,
}) => {
  const [hiddenRows, setHiddenRows] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChangeCorporate = (data, field, id) => {
    const payload = cloneDeep(personalInfo);
    const corporatePlans = payload.corporatePlans.map((item) =>
      item.id === id ? { ...item, [field]: data } : { ...item }
    );
    setPersonalInfo({ ...personalInfo, corporatePlans });
  };

  const handleDeleteCorporate = (id) => {
    const payload = cloneDeep(personalInfo);
    const corporatePlans = payload.corporatePlans.filter(
      (item) => item.id !== id
    );
    setPersonalInfo({ ...personalInfo, corporatePlans });
  };

  const handleChange = (key) => (e, newValue) => {
    let value;
    switch (key) {
      case 'nationality':
        value = newValue;
        break;
      case 'dateOfBirth':
        value = moment(e).startOf('date').format('YYYY-MM-DD');
        break;

      case 'ignoredUnitNumber':
        setPersonalInfo({
          ...personalInfo,
          [key]: get(e, 'target.checked'),
          floor: '',
          unitNumber: '',
        });
        setUnitNumber('');
        return;
      default:
        value = get(e, 'target.value');
        break;
    }
    setPersonalInfo({
      ...personalInfo,
      [key]: value,
      countryCode: isEmpty(personalInfo.countryCode)
        ? 'SG'
        : key === 'countryCode'
        ? value
        : personalInfo.countryCode,
    });
  };

  const handleChangeIdentityType = (e) => {
    setPersonalInfo({
      ...personalInfo,
      identityType: e.target.value,
      nric: '',
    });
  };

  const handleChangeAddress = (data) => {
    setPersonalInfo({
      ...personalInfo,
      address: data.description || '',
      latitude: data.lat || 0,
      longitude: data.lng || 0,
    });
  };
  const handleChangeIdentity = (data, field) => {
    const payload = cloneDeep(personalInfo);
    set(payload, field, data);
    setPersonalInfo(payload);
  };

  const handleChangeUnitNumber = (e) => {
    const raw = e.target.value || '';
    const digitsAndDash = raw.replace(/[^0-9-]/g, '');
    const dashIndex = digitsAndDash.indexOf('-');
    const hasDash = dashIndex >= 0;

    const leftRaw = hasDash ? digitsAndDash.slice(0, dashIndex) : digitsAndDash;
    const rightRaw = hasDash
      ? digitsAndDash.slice(dashIndex + 1).replace(/-/g, '')
      : '';

    const left = leftRaw.slice(0, 2);
    const right = rightRaw.slice(0, 4);
    const display = hasDash ? `${left}-${right}` : left;

    setUnitNumber(display);

    if (UNIT_NUMBER_VALID_REGEX.test(display)) {
      setPersonalInfo({
        ...personalInfo,
        floor: left,
        unitNumber: right,
      });
    } else {
      setPersonalInfo({
        ...personalInfo,
        floor: '',
        unitNumber: '',
      });
    }
  };

  const handleInputUnitNumber = (e) => {
    const inputType = e?.nativeEvent?.inputType || '';
    if (inputType.startsWith('delete')) return;

    const raw = e.target.value || '';
    const digitsOnly = raw.replace(/[^0-9]/g, '');
    if (!raw.includes('-') && digitsOnly.length === 2) {
      e.target.value = `${digitsOnly}-`;
    }
  };

  const TableCellFiltedWrapper = ({ ...props }) => (
    <TableCellFilted
      {...{
        hiddenRows,
        setHiddenRows,
      }}
      {...props}
    />
  );

  const TableHeader = () => (
    <TableHead>
      <TableRow>
        {columnCorporatePlans.map((item) =>
          item.label ? (
            <TableCellFiltedWrapper
              key={item.stateValue}
              label={item.label}
              stateValue={item.stateValue}
            />
          ) : (
            <TableCell key={item.stateValue}></TableCell>
          )
        )}
      </TableRow>
    </TableHead>
  );

  const renderRow = () => (row) =>
    (
      <>
        <FiltedBodyCell hidden={hiddenRows.corporatePlanType}>
          <TextField
            error={isSubmitted && row?.errors?.corporateName ? true : false}
            helperText={isSubmitted && row?.errors?.corporateName}
            value={row.corporatePlanType || ''}
            name="corporateName"
            variant="standard"
            disabled
            onChange={(e) =>
              handleChangeCorporate(e.target.value, 'corporatePlanType', row.id)
            }
          />
        </FiltedBodyCell>
        <FiltedBodyCell hidden={hiddenRows.frontPhoto}>
          <SignedUploadSingle
            accept=".jpg,.png,.jpeg"
            typeUpload="normal"
            onChange={(data) =>
              handleChangeCorporate(data, 'frontPhoto', row.id)
            }
            imageUrlSelected={get(row, 'frontPhoto')}
          />
        </FiltedBodyCell>
        <FiltedBodyCell hidden={hiddenRows.backPhoto}>
          <SignedUploadSingle
            accept=".jpg,.png,.jpeg"
            typeUpload="normal"
            onChange={(data) =>
              handleChangeCorporate(data, 'backPhoto', row.id)
            }
            imageUrlSelected={get(row, 'backPhoto')}
          />
        </FiltedBodyCell>
        <TableCell>
          <IconButton onClick={() => handleDeleteCorporate(row.id)}>
            <Delete />
          </IconButton>
        </TableCell>
      </>
    );

  return (
    <DetailWrapped>
      <LocalizationProvider dateAdapter={MomentUtils}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <DividerHeader title="General Information" />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Full Name"
              value={personalInfo.fullName || ''}
              error={!!errors.fullName}
              helperText={errors.fullName}
              onChange={handleChange('fullName')}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="User ID"
              value={personalInfo.patientShortId || ''}
              variant="filled"
              disabled
            />
          </Grid>
          <Grid item xs={6}>
            <ControlDatepicker
              value={personalInfo.dateOfBirth}
              onChange={handleChange('dateOfBirth')}
              label="Date Of Birth"
              error={!!errors.dateOfBirth}
              inputFormat={FORMAT_DD_MM_YYYY}
              disableFuture
              grid={12}
            />
          </Grid>
          <Grid item xs={6}>
            <InputLabel id="id-label-gender">Gender</InputLabel>
            <Select
              fullWidth
              labelId="id-label-gender"
              value={personalInfo.gender || ''}
              onChange={handleChange('gender')}
            >
              {USER_GENDER.map((item) => (
                <MenuItem value={item.value}>{item.label}</MenuItem>
              ))}
            </Select>
            {errors.gender && (
              <Typography color="error">{errors.gender}</Typography>
            )}
          </Grid>

          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Company Code"
              disabled={!EditableHsStatus.includes(personalInfo.lastHsStatus)}
              value={personalInfo.projectCode || ''}
              onChange={handleChange('projectCode')}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              type="number"
              label="User Value"
              variant="filled"
              value={personalInfo.totalMoneyUsed}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
          </Grid>
          {personalInfo.isRegisterLv2 && (
            <>
              <Grid item xs={6}>
                <InputLabel id="id-label-identity">Type of ID</InputLabel>
                <Select
                  fullWidth
                  labelId="id-label-identity"
                  value={personalInfo.identityType || ''}
                  onChange={handleChangeIdentityType}
                >
                  {ID_TYPE.map((item) => (
                    <MenuItem value={item.value}>{item.label}</MenuItem>
                  ))}
                </Select>
                {errors.identityType && (
                  <Typography color="error">{errors.identityType}</Typography>
                )}
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="NRIC/Passport"
                  value={personalInfo.identityNumber || ''}
                  error={!!errors.identityNumber}
                  helperText={errors.identityNumber}
                  onChange={handleChange('identityNumber')}
                />
              </Grid>
            </>
          )}

          <Grid item xs={6}>
            <TextField
              fullWidth
              select
              label="Ethnic Group"
              value={capitalize(personalInfo.ethnicGroup) || ''}
              onChange={handleChange('ethnicGroup')}
              error={!!errors.ethnicGroup}
              helperText={errors.ethnicGroup}
            >
              {ETHNIC_GROUP.map((item) => (
                <MenuItem value={item.value}>{item.label}</MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={6}>
            <Autocomplete
              options={NATIONALITY}
              value={personalInfo.nationality || ''}
              autoComplete
              onChange={handleChange('nationality')}
              renderInput={(params) => (
                <TextField {...params} label="Nationality" />
              )}
            />
            {errors.roleType && (
              <FormHelperText>{errors.gender}</FormHelperText>
            )}
          </Grid>
          {personalInfo.approveStatus === doctorStatus.Approved ? null : (
            <Grid container spacing={4} style={{ margin: 0 }}>
              <Grid item xs={6}>
                <UploadSingle
                  typeUpload="normal"
                  accept=".jpg,.png,.jpeg"
                  onChange={(data) =>
                    handleChangeIdentity(data, 'lstIdentityUrl[0]')
                  }
                  imageUrlSelected={
                    !isEmpty(lstIdentityUrl) && lstIdentityUrl[0]
                  }
                  uploadButton={
                    <WrapperButtonUpload>
                      <span className="icon">
                        <AddImageOutlineIcon color="#ccc" />
                      </span>{' '}
                      <span className="text">Add ID Picture</span>
                    </WrapperButtonUpload>
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <UploadSingle
                  typeUpload="normal"
                  accept=".jpg,.png,.jpeg"
                  onChange={(data) =>
                    handleChangeIdentity(data, 'lstIdentityUrl[1]')
                  }
                  imageUrlSelected={
                    !isEmpty(lstIdentityUrl) && lstIdentityUrl[1]
                  }
                  uploadButton={
                    <WrapperButtonUpload>
                      <span className="icon">
                        <AddImageOutlineIcon color="#ccc" />
                      </span>{' '}
                      <span className="text">Add ID Picture</span>
                    </WrapperButtonUpload>
                  }
                />
              </Grid>
              {errors.lstIdentityUrl && (
                <Typography style={{ marginLeft: 16 }} color="error">
                  {errors.lstIdentityUrl}
                </Typography>
              )}
            </Grid>
          )}

          <Grid item xs={12}>
            <DividerHeader title="Contact" />
          </Grid>
          {!isChildren && (
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Email"
                value={personalInfo.email || ''}
                error={!!errors.email}
                helperText={errors.email}
                onChange={handleChange('email')}
              />
            </Grid>
          )}
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Notification Email"
              value={personalInfo.notificationEmail || ''}
              error={!!errors.notificationEmail}
              helperText={errors.notificationEmail}
              onChange={handleChange('notificationEmail')}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              disabled={isChildren}
              error={!!errors.mobile}
              helperText={errors.mobile}
              id="phone-input"
              label="Mobile number"
              value={personalInfo.mobile}
              onChange={handleChange('mobile')}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PhoneInput
                      country={personalInfo.countryCode}
                      disabled={isChildren}
                      onChange={handleChange('countryCode')}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          {personalInfo.isRegisterLv2 && (
            <>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Address"
                  error={!!errors.address}
                  helperText={errors.address}
                  value={personalInfo.address || ''}
                  onChange={handleChange('address')}
                />
              </Grid>
              <Grid item xs={6}>
                <InputLabel id="id-label-identity">Unit Number</InputLabel>

                <Typography
                  variant="body2"
                  style={{ color: '#666', marginBottom: 4, marginTop: 2 }}
                >
                  Please key 00-00 if not applicable
                </Typography>
                <CustomTextField
                  error={errors.unitNumber}
                  helperText={errors.unitNumber}
                  value={unitNumber || ''}
                  // label="Unit Number"
                  variant="standard"
                  placeholder="12-34"
                  fullWidth
                  onChange={handleChangeUnitNumber}
                  onInput={handleInputUnitNumber}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">#</InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  error={!!errors.postalCode}
                  variant="standard"
                  value={personalInfo.postalCode}
                  onChange={handleChange('postalCode')}
                  label="Postal Code"
                  helperText={errors.postalCode}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">S</InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </>
          )}
          {personalInfo.isRegisterLv2 && !isChildren && (
            <>
              <Grid item xs={12}>
                <DividerHeader title="Corporate Pictures" />
              </Grid>
              <Grid item xs={12}>
                <InlineTable
                  Header={TableHeader}
                  data={personalInfo.corporatePlans || []}
                  renderRow={renderRow()}
                  style={{ paddingTop: 0 }}
                  noDataHelperText={`This patient does't have any corporate information.`}
                />
              </Grid>
            </>
          )}

          <Grid item xs={12}>
            <DividerHeader title="Other" />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Highlight"
              value={personalInfo.highlight || ''}
              onChange={handleChange('highlight')}
            />
          </Grid>
        </Grid>
      </LocalizationProvider>
    </DetailWrapped>
  );
};

export default PersonalInformation;
